export default __webpack_public_path__ + "static/media/chevron-down.ae24f9f8.svg";